import { DomSanitizer } from '@angular/platform-browser';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'dynamic-image',
    styles: [require('./dynamic-image.component.scss')],
    template: require('./dynamic-image.component.pug')
})
export class DynamicImageComponent {
    @Input() width = 96;
    @Input() image: string;
    @Input() text: string;
    @Input() alt = false;

    constructor(private _sanitizer: DomSanitizer) { }

    get imageUrl(): string {
        if (!this.image) { return null; }
        return `${this.image}?width=${this.ampedN}&height=${this.ampedN}`;
    }

    get ampedN(): number {
        return this._nearestMultipleOfTwo(this.width * 1.5);
    }

    get imgStyle() {
        let tickness = Math.round(this.width * 0.05);
        let opacity = this.alt ? 0.8 : 0.3;

        return this._sanitizer.bypassSecurityTrustStyle(`border: ${tickness}px solid rgba(50, 50, 50, ${opacity}); 
                                                         object-fit: cover; margin: auto; border-radius: 50%; 
                                                         position: relative; width: ${this.width}px; height: ${this.width}px;`);
    }

    get textMargin() {
        return Math.ceil(this.width * 0.06);
    }

    _nearestMultipleOfTwo(n: number): number {
      return  Math.ceil(n / 2) * 2;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/dynamic-image/dynamic-image.component.ts